import { InjectProperty } from '@jack-henry/frontend-utils/di';
import {
    RemoteDepositCaptureService,
    RemoteDepositLocation,
} from '@treasury/domain/remote-deposit-capture';
import { TmBaseComponent } from '@treasury/presentation';
import { TmListColumnRenderer } from '@treasury/presentation/components/tm-list';
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { LocationSelectedPayload, RemoteDepositEvent } from '../containers/remote-deposit.types';

export const tagName = 'location-selection-step';

@customElement(tagName)
export class LocationSelectionStep extends TmBaseComponent {
    @InjectProperty()
    declare private readonly remoteDepositCaptureService: RemoteDepositCaptureService;

    @state()
    private selectedLocation?: RemoteDepositLocation;

    protected render() {
        return html` <tm-list-layout
            .filterSheetHeading=${'Select Location'}
            .columns=${[this.renderLocationColumn] as TmListColumnRenderer<RemoteDepositLocation>[]}
            .fetchItems=${() => this.remoteDepositCaptureService.getLocations()}
            .searchFields=${['name']}
            @select-list-item=${this.handleLocationSelected}
        ></tm-list-layout>`;
    }

    private handleLocationSelected(e: CustomEvent<RemoteDepositLocation>) {
        this.selectedLocation = e.detail;
        this.dispatchEvent(
            new CustomEvent<LocationSelectedPayload>(RemoteDepositEvent.LocationSelected, {
                detail: this.selectedLocation,
            })
        );
        e.currentTarget?.dispatchEvent(new CustomEvent('close', { bubbles: true }));
    }

    private renderLocationColumn(location: RemoteDepositLocation) {
        return html`<div class="flex flex-col my-2">
            <span class="font-medium text-medium overflow-hidden text-ellipsis"
                >${location.name}</span
            >
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    overflow-y: hidden;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: LocationSelectionStep;
    }
}
